import { useState } from 'react';
import { Button } from './ui/button';
import { Bell, BellRing } from 'lucide-react';
import { toast } from 'sonner';
import { ensurePushSubscription } from '../lib/pushClient';

export const NotificationBell = ({ withLabel }) => {
  const [granted, setGranted] = useState(
    typeof Notification !== 'undefined' && Notification.permission === 'granted');

  const enable = async () => {
    try {
      const r = await ensurePushSubscription();
      if (r === 'ok') {
        setGranted(true);
        toast.success('🔔 Notifications activées sur cet appareil');
      } else if (r === 'denied') {
        toast.error('Notifications bloquées — autorisez-les dans les réglages du navigateur');
      } else if (r === 'unsupported') {
        toast.error('Notifications non prises en charge par ce navigateur');
      } else {
        toast.error("Impossible d'activer les notifications");
      }
    } catch (e) {
      toast.error("Impossible d'activer les notifications");
    }
  };

  return (
    <Button variant="ghost" size={withLabel ? 'sm' : 'icon'} onClick={enable}
      className={withLabel ? 'gap-2 w-full justify-start' : ''}
      title={granted ? 'Notifications activées — cliquer pour re-synchroniser' : 'Activer les notifications'}
      data-testid="notification-bell-btn">
      {granted ? <BellRing className="h-4 w-4 text-emerald-600" /> : <Bell className="h-4 w-4" />}
      {withLabel && (granted ? 'Notifications activées' : 'Activer les notifications')}
    </Button>
  );
};
